export const logger = {
  warning(log: string) {
    console.warn(log)
  },
}
